/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_DescInputs */



/**
* | output |
* | --- |
* | "Enable and disable email notifications." |
*
* @param {Options_Notifications_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_desc = /** @type {((inputs?: Options_Notifications_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer et désactiver les notifications par email.")
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail-Benachrichtigungen aktivieren und deaktivieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita e disabilita le notifiche e-mail.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включение и отключение уведомлений по электронной почте.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar y deshabilitar las notificaciones por correo electrónico.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用和禁用电子邮件通知。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("電子メール通知を有効または無効にします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल नोटिफिकेशन को चालू और बंद करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar e desativar notificações por e-mail.")
	return /** @type {LocalizedString} */ ("Enable and disable email notifications.")
});